module.exports = __webpack_public_path__ + "img/standing behind you.5ca70f62.png";